import { styled, TextField, TextFieldProps } from '@mui/material'

/**
 * Custom styled input component using MUI's styled API.
 */
const StyledTextField = styled(TextField)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  width: '100%',
  // Set background color based on theme mode
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.background.paper
  },
  // Style the textarea scrollbar to be thin and subtle (mobile-like)
  '& textarea': {
    // Firefox: make scrollbar thin and set colors
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.grey[400]} transparent`,
    // WebKit (Chrome, Edge, Safari): custom sizes and thumb appearance
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: 10
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    }
  }
}))

/**
 * Basic Input component with custom style
 * This component applies custom styles to the MUI TextField component.
 *
 * @param {TextFieldProps} props - The properties for the input component.
 * @returns {JSX.Element} Returns a styled input component.
 */
const InputBase = (props: TextFieldProps) => {
  return <StyledTextField {...props} />
}

export default InputBase
